// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reel-modal>.modal-wrapper{opacity:1!important;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background-color:rgba(0,0,0,.7)}.reel-modal>.modal-wrapper>.modal{height:100%;padding:0}@media(min-width:768px){.reel-modal>.modal-wrapper{width:90%;height:90%;border-radius:20px}}", ""]);
// Exports
module.exports = exports;
